angular.module('qkr').controller('PasswordRequestResetController', ($scope, $http, $window, appConfig, utils,
																	FormHelper, messageService, gettextCatalog) => {
	$scope.form = {
		username: ''
	};

	$scope.saving = false;

	$scope.errors = {};
	let formHelper = new FormHelper($scope),

	validate = function(username) {
		const errors = {};

		if (utils.hasNoValue(username))
			errors.username = gettextCatalog.getString('Please provide your email address');

		if (!(/^[A-Za-z0-9._%+-]*[A-Za-z0-9]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,4}$/.test($scope.form.username)))
			errors.username = gettextCatalog.getString('The username you have supplied is invalid, please try again');

		$scope.errors = errors;
		return utils.isEmpty(errors);
	},

	responder = function(response) {
		const r = formHelper.handleResponse(response);

		if (r.isSuccess()) {
			messageService.success(gettextCatalog.getString('An email has been sent to your account.'));
			window.setTimeout(() => {
				$window.location.href = appConfig.contextPath;
			}, 4000);
		} else {
			switch (r.responseStatus) {
				case 400 :
					messageService.error(gettextCatalog.getString('There were errors with processing your request.'));
					$scope.errors = formHelper.parseFieldErrors(response);
					$scope.saving = false;
					break;
				case 404 :
					messageService.error(gettextCatalog.getString('A problem was encountered. Please try again.'));
					$scope.saving = false;
					break;
				default :
					messageService.error(gettextCatalog.getString('A problem was encountered. Please try again.'));
					$scope.saving = false;
					break;
			}
		}
	};

    $scope.isCamelCase = function(amICamelCase) {
        if (amICamelCase == null) {
            return false;
        }
        if (amICamelCase.toLowerCase() == amICamelCase) {
            return false;
        } else {
            return true;
        }
    };

    $scope.requestReset = function() {
		if (!validate($scope.form.username)) {
			return;
		}

		$scope.saving = true;

		const payload = {
			username: $scope.form.username,
			scheme: appConfig.scheme,
			host: appConfig.host,
			path: appConfig.pathPrefix + '/auth/resetPassword/'
		};

		/*
		 * Password/requestReset if need change this url it needs change in
		 * ApiFilters as well
		 */
		return $http.post(appConfig.apiUrl + 'password/requestReset', payload).then((promise) => {
			responder(promise);
		}, (promise) => {
			responder(promise);
		});
	};
});



// WEBPACK FOOTER //
// ./src/controllers/password.requestreset.controller.js